import { type PaletteOptions } from '@mui/material'
import { blue, grey } from './customColors'
import { common } from '@mui/material/colors'

// SETUP COLORS
const GREY = grey

const PRIMARY = {
  main: GREY[98],
  contrastText: GREY[70]
}

const SECONDARY = {
  main: blue[500],
  dark: '#09B5EC99',
  contrastText: common.white
}

const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
  contrastText: '#fff'
}

const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#54D62C',
  dark: '#229A16',
  darker: '#08660D'
}

const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01'
}

const ERROR = {
  lighter: '#FF6666',
  light: '#F24949',
  main: '#E62E2E',
  dark: '#CC1414',
  darker: '#B20000',
  contrastText: '#fff'
}

declare module '@mui/material' {
  interface Color {
    0?: string
    10?: string
    15?: string
    20?: string
    25?: string
    30?: string
    35?: string
    40?: string
    45?: string
    55?: string
    60?: string
    65?: string
    70?: string
    75?: string
    80?: string
    85?: string
    90?: string
    91?: string
    92?: string
    93?: string
    94?: string
    95?: string
    96?: string
    97?: string
    98?: string
    99?: string
  }
}

export const palette: Partial<PaletteOptions> = {
  background: {
    default: GREY[98],
    paper: common.white
  },
  text: {
    primary: GREY[70],
    secondary: GREY[50]
  },
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: GREY[95],
  action: {
    active: blue[500],
    hover: GREY[95],
    focus: blue[500],
    selected: blue[500]
    // selectedOpacity: 1
  }
}
